import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/toaster";

// Lazy-load secondary public pages (split per route).
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Partners = lazy(() => import("./pages/Partners"));
const Contact = lazy(() => import("./pages/Contact"));
const Insights = lazy(() => import("./pages/Insights"));
const InsightPost = lazy(() => import("./pages/InsightPost"));
const RevenueOps = lazy(() => import("./pages/RevenueOps"));

// Lazy-load admin pages — never sent to public visitors.
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminEditor = lazy(() => import("./pages/AdminEditor"));

function WithLayout({ children }) {
  return <Layout>{children}</Layout>;
}

function RouteFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-10 h-10 rounded-full border-4 border-[#4a7b9d]/30 border-t-[#4a7b9d] animate-spin" />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            {/* Public site */}
            <Route path="/" element={<WithLayout><Home /></WithLayout>} />
            <Route path="/about" element={<WithLayout><About /></WithLayout>} />
            <Route path="/services" element={<WithLayout><Services /></WithLayout>} />
            <Route path="/partners" element={<WithLayout><Partners /></WithLayout>} />
            <Route path="/insights" element={<WithLayout><Insights /></WithLayout>} />
            <Route path="/insights/:slug" element={<WithLayout><InsightPost /></WithLayout>} />
            <Route path="/revenue-ops" element={<WithLayout><RevenueOps /></WithLayout>} />
            <Route path="/contact" element={<WithLayout><Contact /></WithLayout>} />

            {/* Admin (no public layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/posts/new" element={<AdminEditor />} />
            <Route path="/admin/posts/:id" element={<AdminEditor />} />
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
